// extracted by mini-css-extract-plugin
export default {"testimonialsAndCtaWrapper":"TestimonialsAndCTA_testimonialsAndCtaWrapper__yvljI"};